import api from '@/api/Api'
import apiWithoutAuth from '@/api/ApiWithoutAuth'
import store from '@state/store'
import Table from '@models/table/table'

export const state = {
  uploadDialog: true,
  tables: [],
  tableShared: [],
  allTables: [],
  taskUpload: [],
  uploading: false,
  listCancel: [],
  resetDataTable: true,
  folderId: null,
  folders: [],
  sharedFolders: [],
  sharedPage: 1,
  sharedPerPage: 36,
  sharedFolderId: null,
  myTableRoute: [
    {
      disabled: false,
      id: null,
      name: 'Root'
    }
  ],
  sharedTableRoute: [
    {
      disabled: false,
      id: null,
      name: 'Root'
    }
  ],
  router: [],
  listProperty: []
}

export const getters = {
  tables(state) {
    return state.tables
  },
  allTables(state) {
    return state.allTables
  },
  uploadDialog(state) {
    return state.uploadDialog
  },
  tableShared(state) {
    return state.tableShared
  },
  taskUpload(state) {
    return state.taskUpload
  },
  resetDataTable(state) {
    return state.resetDataTable
  },
  folderId: state => state.folderId,
  folders: state => state.folders,
  sharedFolderId: state => state.sharedFolderId,
  sharedFolders: state => state.sharedFolders,
  myTableRoute: state =>
    state.myTableRoute.map((route, index, array) => ({
      ...route,
      disabled: index === array.length - 1
    })),
  sharedTableRoute: state =>
    state.sharedTableRoute.map((route, index, array) => ({
      ...route,
      disabled: index === array.length - 1
    })),
  listProperty: state => state.listProperty
}

export const mutations = {
  SET_ROUTER(state, newValue) {
    state.router = newValue
  },
  CLOSE_POPUP(state) {
    state.uploadDialog = !state.uploadDialog
  },
  RESET_DATA_TABLE(state) {
    state.resetDataTable = !state.resetDataTable
  },
  SET_TABLES(state, newValue) {
    let oldTables = state.tables
    state.tables = []

    // state.tables = oldTables.concat(newValue)
    const uniqueValuesMap = new Map()
    oldTables.forEach(table => {
      uniqueValuesMap.set(table.id, table)
    })
    newValue.forEach(table => {
      uniqueValuesMap.set(table.id, table)
    })
    const mergedTables = Array.from(uniqueValuesMap.values())
    state.tables = mergedTables
  },
  SET_ALL_TABLES(state, newValue) {
    state.allTables = newValue
  },
  RESET_TABLES(state) {
    state.tables = []
  },
  SET_TABLES_SHARED(state, newValue) {
    let oldVectors = state.tableShared
    state.tableShared = []
    state.tableShared = oldVectors.concat(newValue)
  },
  RESET_TABLES_SHARED(state) {
    state.tableShared = []
  },
  SET_SHARED_FOLDERS(state, payload) {
    state.sharedFolders = payload
  },
  SET_STATUS_UPLOAD(state, newValue) {
    if (state.taskUpload.length > 0) {
      let task = state.taskUpload.find(val => val.id === newValue.id)
      if (task) {
        // if (!task.cancel) {
        //   task.cancel = state.listCancel.find(val => val.id === task.id).cancel
        // }
        task.percent = newValue.percent
      } else {
        if (newValue.percent !== 100) state.taskUpload.push(newValue)
      }
    } else {
      state.taskUpload.push(newValue)
    }
  },
  SET_CANCEL_UPLOAD(state, newValue) {
    state.listCancel.push(newValue)
  },
  DELETE_STATUS_UPLOAD(state, id) {
    if (id) {
      state.taskUpload = state.taskUpload.filter(val => val.id !== id)
    } else {
      state.taskUpload = state.taskUpload.filter(val => val.percent !== 100 || val.error)
    }
    if (state.taskUpload.length <= 0) {
      state.uploading = false
    }
  },
  SET_STATUS(state, newValue) {
    state.uploading = newValue
  },
  SET_TASK(state, newValue) {
    state.taskUpload = state.taskUpload.concat(newValue)
  },
  SET_LIST_ERROR(state, id) {
    let ind = state.taskUpload.findIndex(val => val.id === id)
    if (ind >= 0) {
      state.taskUpload[ind].error = true
    }
  },

  SET_MY_TABLE_ROUTE(state, payload) {
    state.myTableRoute = payload
  },
  SET_SHARED_VECTOR_ROUTE(state, payload) {
    state.sharedTableRoute = payload
  },
  SET_FOLDERS: (state, payload) => {
    state.folders = payload
  },
  SET_FOLDER_ID: (state, payload) => {
    state.folderId = payload
  },
  SET_VECTOR_QTY: (state, payload) => {
    state.vectorQty = payload
  },
  SET_VECTOR_TOTAL: (state, payload) => {
    state.vectorTotal = payload
  },
  SET_SHARED_FOLDER_ID: (state, payload) => {
    state.sharedFolderId = payload
  },
  SET_LIST_PROPERTY: (state, payload) => {
    state.listProperty = payload
  }
}
export const actions = {
  copyToWorkspace({ commit, state }, form) {
    return api.copyTableTo(form).then(response => {
      return response
    })
  },
  getFolder({ commit, state }, form) {
    return api.getDataFolderTable(form).then(response => {
      return response.data.data
    })
  },
  getTable({ commit, state }, data) {
    if (data.reset) commit('RESET_TABLES')
    return api.getTable({ ...data, folderId: state.folderId }).then(response => {
      const tables = response.data.data.tables.data.map(val => new Table(val))
      commit('SET_TABLES', tables)
      commit('SET_FOLDERS', response.data.data.folders)
      return response.data.data
    })
  },
  getTableShared({ commit, state }, data) {
    if (data.reset) commit('RESET_TABLES_SHARED')
    return api.getTableShared({ ...data, folderId: state.sharedFolderId }).then(response => {
      const tables = response.data.data.tables.data.map(val => new Table(val))
      commit('SET_TABLES_SHARED', tables)
      commit('SET_SHARED_FOLDERS', response.data.data.folders)
      return response.data.data
    })
  },
  makeCopyTable({ commit, dispatch, state }, data) {
    return api.makeCopyTable(data).then(response => {
      store.dispatch('task/refresh', {
        workspaceId: data.workspaceId
      })
      return response.data
    })
  },
  async fetchTable({ commit, dispatch, state }, workspaceId) {
    const { data } = await api.getListTables(workspaceId)
    const tables = data.data.map(val => {
      return new Table(val)
    })
    commit('SET_ALL_TABLES', tables)
    commit('RESET_DATA_TABLE')
  },
  deleteTable({ commit, dispatch, state }, data) {
    return api.deleteTable(data).then(response => {
      return response.data
    })
  },
  removeShared({ commit, dispatch, state }, data) {
    return api.removeSharedTable(data).then(response => {
      return response.data
    })
  },
  updateTable({ commit, state }, data) {
    return api.updateTable(data).then(response => {
      return response.data
    })
  },

  uploadTableFile({ commit, dispatch, state }) {
    let tmp = state.taskUpload.find(val => !val.error)
    if (tmp) {
      dispatch('uploadTable', tmp)
        .then(val => {
          if (!val) {
            store.dispatch('message/setNotification', {
              type: 'error',
              active: true,
              message: `Upload failed`
            })
          }
        })
        .catch(er => {
          commit('SET_LIST_ERROR', tmp.id)
          if (er.status_code === 499) {
            store.dispatch('message/setNotification', {
              type: 'success',
              active: true,
              message: 'Task has been canceled'
            })
          } else {
            store.dispatch('message/setNotification', {
              type: 'error',
              active: true,
              message: er.message ? er.message : 'Task has been canceled'
            })
          }
          commit('SET_STATUS', false)
          let check = state.taskUpload.filter(val => !val.error)
          if (check.length > 0) {
            dispatch('startUpload')
          }
        })
    }
  },
  uploadTable({ commit, state, dispatch }, request) {
    return apiWithoutAuth
      .uploadTableS3(request.data)
      .then(response => {
        dispatch('createTaskUpload', request)
        commit('DELETE_STATUS_UPLOAD')
        if (state.taskUpload.length > 0) {
          let tmp = state.taskUpload.find(val => !val.error)
          if (tmp) {
            dispatch('uploadTable', tmp)
          } else {
            commit('SET_STATUS', false)
          }
        } else {
          commit('SET_STATUS', false)
        }
        return response
      })
      .catch(er => {
        store.dispatch('message/setNotification', {
          type: 'error',
          active: true,
          message: er.message ? er.message : 'Server error'
        })
      })
  },
  createTaskUpload({ commit, state, dispatch }, data) {
    return api
      .createTaskUploadTable(data.taskData)
      .then(val => {
        store.dispatch('message/setNotification', {
          type: 'success',
          active: true,
          message: val.data.message ? val.data.message : 'Successful'
        })
        store.dispatch('task/refresh', {
          workspaceId: data.taskData.wksId,
          folderId: state.currentFolder
        })
      })
      .catch(er => {
        store.dispatch('message/setNotification', {
          type: 'error',
          active: true,
          message: er.message ? er.message : 'Server error'
        })
      })
  },
  checkStatusUpload({ commit, dispatch, state }) {
    const taskCreated = state.taskUpload.find(val => !val.error)
    if (taskCreated) dispatch('uploadTableFile', taskCreated)
    else commit('SET_STATUS', false)
  },
  startUpload({ commit, dispatch, state }, data) {
    if (!state.statusUpload) {
      commit('SET_STATUS', true)
      dispatch('uploadTableFile')
    }
    // state.taskUpload.push(data)
    // if (!state.uploading) {
    //   dispatch('checkStatusUpload')
    // }
  },

  createFolder: async ({ commit, dispatch }, { workspaceId, name, folderId }) => {
    const res = await api.createTableFolder({ folderId, workspaceId, name })
    commit('RESET_DATA_TABLE')
    return res
  },
  selectFolder: async ({ commit, dispatch }, { folder, workspaceId }) => {
    commit('SET_FOLDER_ID', folder.id)
    dispatch('changeMyTableRoute', { folder })
  },
  selectSharedFolder: async ({ commit, dispatch }, { folder, workspaceId }) => {
    commit('SET_SHARED_FOLDER_ID', folder.id)
    dispatch('changeSharedVectorRoute', { folder })
  },
  changeMyTableRoute: ({ commit, state }, { folder }) => {
    const index = state.myTableRoute.findIndex(route => route.id === folder.id)
    if (folder.id === null) {
      commit('SET_MY_TABLE_ROUTE', [
        {
          id: null,
          name: 'root'
        }
      ])
    } else if (index !== -1) {
      commit('SET_MY_TABLE_ROUTE', state.myTableRoute.slice(0, index + 1))
    } else {
      commit('SET_MY_TABLE_ROUTE', [...state.myTableRoute, folder])
    }
  },
  changeSharedVectorRoute: ({ commit, state }, { folder }) => {
    const index = state.sharedTableRoute.findIndex(route => route.id === folder.id)
    if (folder.id === null) {
      commit('SET_SHARED_VECTOR_ROUTE', [
        {
          id: null,
          name: 'root'
        }
      ])
    } else if (index !== -1) {
      commit('SET_SHARED_VECTOR_ROUTE', state.sharedTableRoute.slice(0, index + 1))
    } else {
      commit('SET_SHARED_VECTOR_ROUTE', [...state.sharedTableRoute, folder])
    }
  },
  renameFolder: async ({ commit, dispatch, state }, { workspaceId, folderId, name }) => {
    const res = await api.renameTableFolder({ workspaceId, folderId, name })
    commit('RESET_DATA_TABLE')
    return res
  },
  moveFolder: async ({ commit, dispatch, state }, { workspaceId, folderId, parentId }) => {
    const res = await api.moveTableFolder({ workspaceId, folderId, parentId })
    commit('RESET_DATA_TABLE')
    return res
  },
  deleteFolder: async ({ commit, dispatch, state }, { workspaceId, folderId }) => {
    const res = await api.deleteTableFolder({ workspaceId, folderId })
    commit('RESET_DATA_TABLE')
    return res
  },
  shareFolder: async ({ commit, dispatch, state }, { workspaceId, folderId, emails }) => {
    await api.shareTableFolder({ workspaceId, folderId, emails })
    commit('RESET_DATA_TABLE')
  },
  makeCopyFolder: async ({ commit, dispatch, state }, { workspaceId, folderId }) => {
    const res = await api.makeCopyTableFolder({ workspaceId, folderId })
    commit('RESET_DATA_TABLE')
    store.dispatch('task/refresh', { workspaceId })
    return res
  },
  removeSharedFolder: async ({ commit, dispatch, state }, { folderId }) => {
    await api.removeSharedTableFolder({ folderId })
    commit('RESET_DATA_TABLE')
  },
  removeSharedFolderUser: async ({ commit, dispatch, state }, { workspaceId, folderId, email }) => {
    await api.removeSharedTableFolderUser({ workspaceId, folderId, email })
    commit('RESET_DATA_TABLE')
  },
  resetRoute: ({ commit }) => {
    commit('SET_MY_TABLE_ROUTE', [
      {
        disabled: false,
        id: null,
        name: 'Root'
      }
    ])
    commit('SET_SHARED_VECTOR_ROUTE', [
      {
        disabled: false,
        id: null,
        name: 'Root'
      }
    ])
  },
  afterSelectWorkspace({ commit, dispatch, rootState }) {
    let workspaceId = rootState.auth.currentWorkspace
    commit('SET_ROUTER', [
      {
        text: 'Root',
        disabled: true,
        id: ''
      }
    ])
    dispatch('fetchTable', workspaceId)
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/table.js